import BaseAPIService from './baseAPI';
import { PlatformDraft } from '../types/api';

export interface SocialPostResult {
  platform: string;
  social_post_id?: string | null;
  platform_url?: string;
  status: 'published' | 'failed' | 'scheduled';
  scheduled_time?: string | null;
  error?: string | null;
}

export interface MultiPlatformPostRequest {
  post_id: string;
  platforms: string[];
  custom_content?: Record<string, string>;
  platform_content?: Record<string, PlatformDraft>;
}

export interface MultiPlatformPostResponse {
  message: string;
  data: {
    results: SocialPostResult[];
  };
}

class SocialAPIService extends BaseAPIService {
  async postToMultiplePlatforms(
    payload: MultiPlatformPostRequest
  ): Promise<MultiPlatformPostResponse> {
    return this.post<MultiPlatformPostResponse>('/social/post/multi', payload);
  }
}

export const socialAPI = new SocialAPIService();
export default socialAPI;
